/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsReportsUnsubscribeEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsReportsUnsubscribeEntryPoint: EntryPoint<
	AssetsReportsUnsubscribeEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsReportsUnsubscribeEntryPointComponent>(
		/* webpackChunkName: "async-assets-reports-unsubscribe-entrypoint" */ './CmdbAssetsReportsUnsubscribe.tsx',
	),
	getPreloadProps: () => ({}),
});
